import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { BehaviorSubject, Observable } from 'rxjs'
import { SkillSetSpec } from '../skill-set-spec'
import { IdValidator } from '../../../../../features/validators/id-validator'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { ProcessingTimeSpecTableComponent } from '../../capacities/processing-time-spec-table/processing-time-spec-table.component'
import { ConstraintSpecTableComponent } from '../../constraints/constraint-spec-table/constraint-spec-table.component'
import { MatBadge } from '@angular/material/badge'
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs'
import { MatCheckbox } from '@angular/material/checkbox'
import { ElderValidationErrorDirective } from '@elderbyte/ngx-starter'
import { FormsModule } from '@angular/forms'
import { MatInput } from '@angular/material/input'
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-skill-set-spec-detail',
  templateUrl: './skill-set-spec-detail.component.html',
  styleUrls: ['./skill-set-spec-detail.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    MatError,
    ElderValidationErrorDirective,
    MatCheckbox,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    MatBadge,
    ConstraintSpecTableComponent,
    ProcessingTimeSpecTableComponent,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class SkillSetSpecDetailComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly _skillSet$ = new BehaviorSubject<SkillSetSpec>(null)

  public readonly idValidatorPattern = IdValidator.pattern

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Properties                                                              *
   *                                                                         *
   **************************************************************************/

  public get skillSetSpec$(): Observable<SkillSetSpec> {
    return this._skillSet$.asObservable()
  }

  public get skillSetSpec(): SkillSetSpec {
    return this._skillSet$.getValue()
  }

  @Input()
  public set skillSetSpec(skillSet: SkillSetSpec) {
    if (skillSet) {
      this._skillSet$.next(skillSet)
    }
  }
}
